export default __webpack_public_path__ + "static/media/bigsister.1cc5805a.png";